import React, { useEffect } from "react";
import { Container, Grid, Button } from "@mui/material";
import { useAuth } from "hooks/useAuth";
import { useNavigate } from "react-router-dom";

const Profil = () => {
  const { logOut } = useAuth();
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (!user) {
      navigate("/auth");
    }
  }, [user, navigate]);

  return (
    <Container maxWidth={"lg"}>
      <Grid justifyContent={"center"} container>
        <Grid item>
          <Button
            onClick={logOut}
            color="secondary"
            //startIcon={<GoogleIcon />}
            variant="contained"
          >
            Se déconnecter
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Profil;
